export const CANADA_STATE_CODES = [
  { value: 'XA', text: 'XA - Alberta' },
  { value: 'XB', text: 'XB - New Brunswick' },
  { value: 'XC', text: 'XC - British Columbia' },
  { value: 'XM', text: 'XM - Manitoba' },
  { value: 'XN', text: 'XN - Nova Scotia' },
  { value: 'XO', text: 'XO - Ontario' },
  { value: 'XP', text: 'XP - Prince Edward Island' },
  { value: 'XQ', text: 'XQ - Quebec' },
  { value: 'XS', text: 'XS - Saskatchewan' },
  { value: 'XT', text: 'XT - Northwest Territories' },
  { value: 'XV', text: 'XV - Nunavut' },
  { value: 'XW', text: 'XW - Newfoundland' },
  { value: 'XY', text: 'XY - Yukon Territory' }
]
